import _extends from "@babel/runtime/helpers/esm/extends";
import React, { useState, useMemo, useContext } from 'react';
import { StyledMenu, StyledMenuWrap, StyledMenuWrapBox, StyledMenuButton, StyledMenuButtonLine, StyledMenuButtonClose } from './styles.js';
import { jsx as ___EmotionJSX } from "@emotion/react";
export var MenuContext = /*#__PURE__*/React.createContext(false);
export function MenuButtonClose(props) {
  var _useContext = useContext(MenuContext),
      close = _useContext.close;

  return ___EmotionJSX(StyledMenuButtonClose, _extends({
    id: "menuButtonClose",
    className: props.className,
    onClick: close,
    style: props.style
  }, process.env.ENV_RAW ? null : props.uiEvents), props.children);
}
export function MenuButton(props) {
  var _useContext2 = useContext(MenuContext),
      open = _useContext2.open;

  return ___EmotionJSX(StyledMenuButton, _extends({
    id: "menuButton",
    className: props.className,
    onClick: open,
    style: props.style
  }, process.env.ENV_RAW ? null : props.uiEvents), ___EmotionJSX(StyledMenuButtonLine, null), ___EmotionJSX(StyledMenuButtonLine, null), ___EmotionJSX(StyledMenuButtonLine, null), props.children);
}
export function MenuWrapBox(props) {
  var _useContext3 = useContext(MenuContext),
      isOpen = _useContext3.isOpen;

  return ___EmotionJSX(StyledMenuWrapBox, _extends({
    id: "menuWrapBox",
    className: props.className,
    style: props.style,
    isOpen: isOpen
  }, process.env.ENV_RAW ? null : props.uiEvents), props.children);
}
export function MenuWrap(props) {
  return ___EmotionJSX(StyledMenuWrap, _extends({
    id: props.name,
    className: props.className,
    style: props.style
  }, process.env.ENV_RAW ? null : props.uiEvents), props.children);
}
export function Menu(props) {
  var _useState = useState(false),
      open = _useState[0],
      setOpen = _useState[1];

  var context = useMemo(function () {
    return {
      isOpen: open,
      open: function open() {
        return setOpen(true);
      },
      close: function close() {
        return setOpen(false);
      }
    };
  }, [open, setOpen]);
  return ___EmotionJSX(MenuContext.Provider, {
    value: context
  }, ___EmotionJSX(StyledMenu, _extends({
    id: props.name,
    className: props.className,
    style: props.style,
    layout: props.layout
  }, process.env.ENV_RAW ? null : props.uiEvents), props.children));
}